<template>
  <div>
    <h3 class="mb-3">Просмотр отзыва</h3>
    <div v-if="review">
      <div class="mb-3">
        <h2 class="mb-2">ФИО</h2>
        <va-input :value="getReviewerName()" disabled />
      </div>
      <div class="mb-3">
        <h2 class="mb-2">Телефон</h2>
        <va-input :value="(review && review.phone) || '-'" disabled />
      </div>
      <div class="mb-3" v-if="review && review.email">
        <h2 class="mb-2">Email</h2>
        <va-input :value="review.email" disabled />
      </div>
      <div class="mb-3">
        <h2 class="mb-2">Рейтинг</h2>
        <div class="rating-display">
          <span v-for="i in 5" :key="i" class="star" :class="{ 'star-filled': i <= ((review && review.rating) || 0) }">
            ★
          </span>
        </div>
      </div>
      <div class="mb-3">
        <h2 class="mb-2">Текст отзыва</h2>
        <va-input
          :value="(review && review.text) || '-'"
          type="textarea"
          :min-rows="4"
          :max-rows="8"
          disabled
        />
      </div>
      <div class="mb-3" v-if="review && review.images && review.images.length > 0">
        <h2 class="mb-2">Фотографии</h2>
        <div class="images-grid">
          <div
            v-for="(image, index) in review.images"
            :key="index"
            class="image-item"
          >
            <img
              :src="image.url || image"
              :alt="`Фото отзыва ${index + 1}`"
              @click="openImageModal(image.url || image, index)"
              class="review-image"
            />
          </div>
        </div>
      </div>
      <div class="mb-3">
        <h2 class="mb-2">Статус</h2>
        <va-input
          :value="getStatusText(review && review.status)"
          disabled
          :class="getStatusClass(review && review.status)"
        />
      </div>
      <div class="mb-3">
        <h2 class="mb-2">Дата создания</h2>
        <va-input :value="formatDate(review && review.created_at)" disabled />
      </div>
    </div>
    <div class="mt-3">
      <va-button color="primary" @click.prevent="$emit('close')">
        Закрыть
      </va-button>
    </div>
    
    <!-- Модалка для просмотра изображения -->
    <va-modal v-model="imageModalVisible" size="large" hide-default-actions>
      <div class="image-modal-content">
        <img :src="selectedImage" alt="Просмотр изображения" class="modal-image" />
        <div class="mt-3 text-center">
          <va-button color="primary" @click="imageModalVisible = false">
            Закрыть
          </va-button>
        </div>
      </div>
    </va-modal>
  </div>
</template>

<script>
export default {
  name: 'ReviewView',
  props: {
    review: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      imageModalVisible: false,
      selectedImage: '',
    };
  },
  methods: {
    getReviewerName() {
      if (!this.review) return 'Анонимный пользователь';
      if (this.review.is_anonymous || !this.review.name) {
        return 'Анонимный пользователь';
      }
      return this.review.name;
    },
    formatDate(date) {
      if (!date) return '-';
      try {
        const d = new Date(date);
        return d.toLocaleString('ru-RU', { timeZone: 'Asia/Omsk' });
      } catch (e) {
        return date;
      }
    },
    getStatusText(status) {
      if (!status) return '-';
      const statusMap = {
        approved: 'Проверено',
        disapproved: 'Скрыто',
        deleted: 'Удалено',
        pending: 'На модерации',
      };
      return statusMap[status] || status || '-';
    },
    getStatusClass(status) {
      if (!status) return '';
      if (status === 'approved') {
        return 'status--success';
      }
      if (status === 'disapproved' || status === 'deleted') {
        return 'status--error';
      }
      return '';
    },
    openImageModal(imageUrl, index) {
      this.selectedImage = imageUrl;
      this.imageModalVisible = true;
    },
  },
};
</script>

<style scoped lang="scss">
.rating-display {
  display: flex;
  gap: 4px;
  font-size: 24px;
  line-height: 1;
}

.star {
  color: #ddd;
  transition: color 0.2s;
  
  &-filled {
    color: #ffc107;
  }
}

.images-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 16px;
  margin-top: 8px;
}

.image-item {
  position: relative;
  width: 100%;
  padding-top: 100%; /* Квадратное соотношение */
  overflow: hidden;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
}

.review-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  cursor: pointer;
  transition: transform 0.2s;
  
  &:hover {
    transform: scale(1.05);
  }
}

.image-modal-content {
  text-align: center;
}

.modal-image {
  max-width: 100%;
  max-height: 70vh;
  object-fit: contain;
  border-radius: 8px;
}

.status--success ::v-deep .va-input__input {
  color: #42ba96;
  font-weight: bold;
}

.status--error ::v-deep .va-input__input {
  color: #ff3333;
  font-weight: bold;
}
</style>

